module.exports = __webpack_public_path__ + "static/media/logo.219360c9.svg";